import { z } from "zod";
/*
 * Workspace change feed (decision 0002). Thin events: resource identity plus
 * operation, never payloads — consumers refetch the resource by id. `seq` is
 * a per-tenant monotonic cursor; holding the highest seen seq is the only
 * client-side sync state required.
 */
export const workspaceResourceTypeSchema = z.enum([
    "channel",
    "channel_post",
    "object_type",
    "field",
    "record",
    "view",
    "file",
    "memory",
    "inbox_item",
    "session",
    "navigation_pin",
    "channel_group",
    "channel_pin",
]);
export const workspaceEventOperationSchema = z.enum(["upsert", "delete"]);
export const workspaceEventSchema = z.object({
    seq: z.number().int().positive(),
    organisationId: z.string().trim().min(1).optional(),
    resourceType: workspaceResourceTypeSchema,
    resourceId: z.string().trim().min(1),
    channelId: z.string().trim().min(1).optional(),
    operation: workspaceEventOperationSchema,
    createdAt: z.number().int().nonnegative(),
});
export const listWorkspaceEventsQuerySchema = z.object({
    afterSeq: z.coerce.number().int().nonnegative().optional(),
    limit: z.coerce.number().int().min(1).max(500).default(500),
});
export const listWorkspaceEventsResponseSchema = z.object({
    events: z.array(workspaceEventSchema),
    cursor: z.number().int().nonnegative(),
    isDone: z.boolean(),
    /** Current end of the tenant's feed — read it before a snapshot, then follow deltas from it. */
    tip: z.number().int().nonnegative(),
});
/*
 * Usage metering (plan 005): tenant-level daily metric snapshots.
 */
export const usageSnapshotsQuerySchema = z.object({
    from: z.coerce.number().int().nonnegative(),
    to: z.coerce.number().int().nonnegative(),
    metricKey: z.string().trim().min(1).max(120).optional(),
});
export const usageSnapshotSchema = z.object({
    metricKey: z.string(),
    periodStart: z.number().int().nonnegative(),
    value: z.number().int().nonnegative(),
});
